
import Sticker from "../../../assets/filled/Sticker.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StickerIcon({ className, dataTestid = "StickerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Sticker data-testid={dataTestid} className={classes} {...rest} />
  );
}
